import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';

@Component({
  selector: 'app-view-saleorder',
  templateUrl: './view-saleorder.component.html',
  styleUrls: ['./view-saleorder.component.scss']
})
export class ViewSaleorderComponent implements OnInit {

  saleOrderDetails: object;
  storeDetails: object;
  saleOrderItemDetails: object;
  employeeComments: object;
  contactComments: object;
  userDetails: object;

  constructor(
    private apiService: ApiService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.getSingleSaleOrderDetails();
    let initialData = this.route.snapshot.data;
    if(initialData.store['response']['status'] === 1){
      this.storeDetails = initialData.store['response']['data']['store'];
    }
    if(initialData.userDetails['response']['status'] === 1){
      this.userDetails = initialData.userDetails['response']['data']['users'];
    }
  }

  getSingleSaleOrderDetails() {
    let uuid = this.route.snapshot.params.uuid;
    this.apiService.getSingleSaleOrder(uuid).subscribe(data => {
      if(data['response']['status'] === 0) {
        this.notification.error(data['response']['message'], 5000);
      }else if(data['response']['status'] === 1) {
        let resData = data['response']['data'];
        if(!!resData['sale_order']) {
          this.saleOrderDetails = resData['sale_order'];
        }
        if(resData['sale_order_items'].length > 0) {
          this.saleOrderItemDetails = resData['sale_order_items'];
        }
        if(resData['employee_comments'].length > 0) {
          this.employeeComments = resData['employee_comments'];
        }
        if(resData['contact_comments'].length > 0) {
          this.contactComments = resData['contact_comments'];
        }
      }else if(data['response'].status === 2 || data['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: data['response']
        });
      }else if(data['response']['status'] === 6) {
        this.notification.error(data['response']['message'], 5000);
      }
    }, err => {
      console.log(err)
    })
  }

  goBack() {
    this.location.back();
  }

}
